import type { ColumnsType } from 'antd/es/table';
import type { TFunction } from 'i18next';

import type {
  CreditTransactionData,
  CreditTransactionType,
} from '@shared/api/endpoints/credit/credit-endpoints';
import { DateService } from '@shared/services/date';

import { formatNumber } from '../../../lib/utils';

export const SCROLL_THRESHOLD = 120;
export const TABLE_SCROLL_Y = 360;

export const buildTransactionTypeOptions = (t: TFunction<'translation', 'billing'>) => [
  { value: 'purchase', label: t('transactions.types.purchase') },
  { value: 'manual_topup', label: t('transactions.types.manual_topup') },
  { value: 'chat_charge', label: t('transactions.types.chat_charge') },
  { value: 'lead_charge', label: t('transactions.types.lead_charge') },
  { value: 'bonus', label: t('transactions.types.bonus') },
] satisfies Array<{ value: CreditTransactionType; label: string }>;

export const buildTransactionColumns = (
  t: TFunction<'translation', 'billing'>,
): ColumnsType<CreditTransactionData> => [
  {
    title: t('transactions.columns.amount'),
    dataIndex: 'amount',
    key: 'amount',
    width: 200,
    render: (value: number) => (
      <span>
        {t('transactions.credits', { count: value, countFormatted: formatNumber(value) })}
      </span>
    ),
  },
  {
    title: t('transactions.columns.type'),
    dataIndex: 'type',
    key: 'type',
    width: 200,
    render: (value: CreditTransactionType) => t(`transactions.types.${value}`),
  },
  {
    title: t('transactions.columns.date'),
    dataIndex: 'created_at',
    key: 'created_at',
    width: 200,
    render: (value: string) => DateService.format(value, 'DD.MM.YYYY, HH:mm'),
  },
  {
    title: t('transactions.columns.comment'),
    dataIndex: 'comment',
    key: 'comment',
    width: 200,
    ellipsis: true,
    render: (value: string) => value || t('transactions.emptyComment'),
  },
];
